import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/react'
import './Gallery.css'
import ModalImage from "react-modal-image";
 const Gallery = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        Gallery
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent style={{display:'block'}}>
                <ModalImage small={require('./Assets/skater7.jpeg')}
                    large={require('./Assets/skater7.jpeg')} className="image" width="122" height="122"/>
                    <br />
                <ModalImage small={require('./Assets/skater6.jpg')} large={require('./Assets/skater6.jpg')} className="image" width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/coach2.jpg')} large={require('./Assets/coach2.jpg')} id="3" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/coach.jpg')} large={require('./Assets/coach.jpg')} id="4" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/skater4.jpg')} large={require('./Assets/skater4.jpg')} id="5" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/skater5.jpg')} large={require('./Assets/skater5.jpg')} id="6" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/2.jpeg')} large={require('./Assets/2.jpeg')} id="7" className="image" width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/3.jpeg')} large={require('./Assets/3.jpeg')}id="8" className="image" width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/4.jpeg')} large={require('./Assets/4.jpeg')} id="9" className="image" width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/5.jpeg')} large={require('./Assets/5.jpeg')} id="10" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/6.jpeg')} large={require('./Assets/6.jpeg')} id="11"className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/7.jpeg')} large={require('./Assets/7.jpeg')} id="12" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/8.jpeg')} large={require('./Assets/8.jpeg')} id="13" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/10.jpeg')} large={require('./Assets/10.jpeg')} id="14" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/11.jpeg')} large={require('./Assets/11.jpeg')} id="15" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/12.jpeg')} large={require('./Assets/12.jpeg')}id="16" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/13.jpeg')} large={require('./Assets/13.jpeg')} id="17" className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/14.jpeg')} large={require('./Assets/14.jpeg')} id="18" className="image"width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/15.jpeg')} large={require('./Assets/15.jpeg')} id="19" className="image"width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/16.jpeg')} large={require('./Assets/16.jpeg')} id="20" className="image"width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/17.jpeg')} large={require('./Assets/17.jpeg')} id="21" className="image"width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/18.jpeg')} large={require('./Assets/18.jpeg')} id="22" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/19.jpeg')} large={require('./Assets/19.jpeg')} id="23" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/20.jpeg')} large={require('./Assets/20.jpeg')} id="24" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/21.jpeg')} large={require('./Assets/21.jpeg')} id="25" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/22.jpeg')} large={require('./Assets/22.jpeg')} id="26" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/23.jpeg')} large={require('./Assets/23.jpeg')} id="27" className="image" width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/24.jpeg')} large={require('./Assets/24.jpeg')} id="28" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/25.jpeg')} large={require('./Assets/25.jpeg')} id="28" className="image"width="122" height="122"/>
                <br />
                <ModalImage small={require('./Assets/skater2.jpg')} large={require('./Assets/skater2.jpg')} id="29"className="image" width="122" height="122" />
                <br />
                <ModalImage small={require('./Assets/skater3.jpg')} large={require('./Assets/skater3.jpg')} id="30" className="image" width="122" height="122" />
            </IonContent>
        </IonPage>
    )
}

export default Gallery
